import ChooseCompanyPage from "./ChooseCompany/ChooseCompanyPage";

const routes = [
    {path : 'user/no-company', component : () => <ChooseCompanyPage/>, isSidebar : false, isPublic : false , permissions:['change_company']},
]

export default routes;